import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JoiEvent } from 'src/app/store/events.era';
import { Program } from 'globals/store/programs.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { Asset } from 'globals/store/assets.data';
import { performerDisplayTypes } from '../../store/performers.era';
import { exhibitorDisplayTypes } from 'globals/store/exhibitors.data';
import { JoiResource } from 'globals/store/resources.data';
import { TagPanelData } from 'globals/store/tags.data';
import { programSessionsActivitesMegaTagReselector } from '../../store/reselectors/programs.reselector';
import { exhibitorStandIdsByProgramIdReselector } from '../../store/reselectors/exhibitors.reselector';
import { TagPanelViewComponent } from '../manage/tag-panel-view.component';
import { IconHolderComponent } from '../logistics/icon-holder.component';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { SubtitleWrapperComponent } from 'src/app/components/wrappers/subtitle-wrapper.component';
import { PhotoComponent } from 'src/app/components/photo';
import { ViewSetupViewComponent } from './onsite.dialog.viewSetup.view.component';
import { CommonModule } from '@angular/common';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { AssetsComponent } from '../assets/assets.component';
import { AssetLinkComponent } from '../assets/asset-link.component';
import { LabelTierDialogComponent } from 'src/app/components/label-marker/label-tier.dialog.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { DialogTitleComponent } from '../program/dialog-title';
import { DatetimeComponent } from 'src/app/components/datetime.component';

@Component({
    selector: 'view-program-dialog',
    template: `
<div class="view_detail_dialog joi-dialog">
  <dialog-title [title]="'Room/Location Information'" [backgroundColor]="uiService.labelsByType.program.color" ></dialog-title>
  <icon class="close" aria-label="Close" (click)="dialogRef.close()" matIcon="close"></icon>
  <div mat-dialog-content *ngIf="event.venues[program.venueId] || { venue: null, address: null } as venue">
      <div class="field sm">
          <span *ngIf="program.programConfirmed" class="confirmed_tick"><icon icon="tick_24px"></icon></span>
          <b>{{program.title || 'Unnamed '+ uiService.programTerm.btn +'...'}}</b>
      </div>
      <div class="field sm" *ngIf="program.date">
          <span *ngIf="program.dateConfirmed" class="confirmed_tick"><icon icon="tick_24px"></icon></span>
          <div class="dd" [appdatetime]="programDate" format="EEEE d MMMM y"></div>
      </div>
      <div class="field" *ngIf="program.location">
          <h5>VENUE ROOM/LOCATION</h5>
         <span *ngIf="program.locationConfirmed" class="confirmed_tick"><icon icon="tick_24px"></icon></span><div class="inline">{{program.location}}</div>
      </div>
      <div class="field" *ngIf="!!venue.venue">
          <h5>VENUE NAME</h5>
          <span *ngIf="program.venueConfirmed" class="confirmed_tick"><icon icon="tick_24px"></icon></span><div class="inline">{{ venue.venue }}</div>
      </div>
      <div class="field" *ngIf="!!venue.address">
          <h5>VENUE ADDRESS</h5>
          <div class="value">{{ venue.address }}</div>
      </div>
      <div class="group">
        <h5>PROGRAM LABELS</h5>
        <div class="not_found" *ngIf="!program.labels || program.labels.length === 0">No labels</div>
        <label-tier [labels]="program.labels" [template]="program.label_template || event.program_labels"></label-tier>
      </div>

      <expanding-wrapper class="group" *ngIf="{ assets: program?.assetIds | idsToItems:assets } as vars"
        [title]="'ROOM/LOCATION ASSETS'"
        [padded]="true"
        [borderGreyOnCollapse]="true"
      >
        <div class="header-right icon-holder" *ngIf="{ n: ((program?.assetIds || []) | idsToItems:event.assets).length } as vars">
          <icon-holder *ngIf="!!vars.n" [icon]="'assets'" [count]="vars.n"></icon-holder>
        </div>
        <div class="not_found" *ngIf="!vars.assets?.length">No files</div>
        <asset-link *ngFor="let asset of vars.assets"
          (click)="$event.stopPropagation()"
          [asset]="asset"
          [onlyLink]="true"
        ></asset-link>
      </expanding-wrapper>

    <div class="group" *ngIf="(program?.setupIds || []) | idsToItems:program.setups as setups">
      <div class="name">SETUPS</div>
      <div class="not_found" *ngIf="!setups.length">No Setups</div>
      <expanding-wrapper *ngFor="let setup of setups" 
        [title]="setup.name"
        [padded]="true"
        [borderGreyOnCollapse]="true"
      >
        <view-setup-view [setupId]="setup.id" [programId]="program.id"></view-setup-view>
      </expanding-wrapper>
    </div>

    <div class="group" *ngIf="(exhibitorStandIds || []) | idsToItems:event.exhibitorStands as stands">
      <div class="name">EXHIBITOR STANDS</div>
      <div class="not_found" *ngIf="!exhibitorStandIds?.length">No Exhibitor Stands</div>

      <expanding-wrapper *ngFor="let stand of stands; let i = index"
        class="exhibitorStands"
        [padded]="true"
        [borderGreyOnCollapse]="true"
        [title]="stand?.name"
      >
        <div class="header-left">{{ event.standTypes[stand.standTypeId]?.name }}</div>
        <div class="header-right" *ngIf="event.exhibitors[stand.exhibitorId] as exhibitor">
          <photo [size]="24" [logo]="true" [data]="{title:exhibitor?.name, photoURL: exhibitor.logoUrl}"></photo>
          {{ exhibitor?.name }}
        </div>
        <subtitle-wrapper [title]="'Stand notes'" [emptyText]="stand.standNotes ? '' : 'No stand notes'">
          <div>{{ stand.standNotes }}</div>
        </subtitle-wrapper>
        <subtitle-wrapper [title]="'Stand requests'" [emptyText]="stand.requests?.length ? '' : 'No requests'">
          <div *ngFor="let request of stand.requests">{{ request.requestText }}</div>
        </subtitle-wrapper>
      </expanding-wrapper>

    <expanding-wrapper class="group"
      [title]="'ROOM/LOCATION TAGS'"
      [padded]="true"
      [borderGreyOnCollapse]="true"
    >
      <div class="header-right icon-holder">
        <icon-holder *ngIf="!!tagPanelDatas[program.id]?.count" [count]="tagPanelDatas[program.id]?.count"></icon-holder>
      </div>
      <tag-panel-view 
        [tagData]="tagPanelDatas[program.id]"
        [readOnly]="true"
        [noHeaders]="false"
        [fromLogistics]="true"
        [performers]="event?.performers"
        [sponsors]="event?.sponsors"
        [exhibitors]="event?.exhibitors"
        [resources]="event?.resources"
        [workforce]="event?.workforce"
        [attendees]="event?.attendees"
      ></tag-panel-view>  
    </expanding-wrapper>
  </div>
</div>
`,
    styleUrls: [`onsite.page.scss`],
    styles: [`
  expanding-wrapper, subtitle-wrapper { display: flex; margin-top: 10px; }
  subtitle-wrapper.notes { margin-top: -10px; }
  :host ::ng-deep asset-link asset-card { margin-top: 3px; }  
  ::ng-deep expanding-wrapper.exhibitorStands {
    .inner-content.padded { padding: 0 15px !important; }
    .header-right { display: flex; align-items: center; }
  }
  ::ng-deep exhibitor-stands {
    .empty-text { font-style: italic; color: var(--light-text); margin-bottom: 10px; }
    status-wrapper { width: 100%; max-width: unset; min-width: unset; }  
  }
    
`],
    standalone: true,
    imports: [TagPanelViewComponent, IconHolderComponent, ExpandingWrapperComponent, SubtitleWrapperComponent, PhotoComponent, ViewSetupViewComponent, CommonModule, IdsToItemsPipe, AssetLinkComponent, LabelTierDialogComponent, IconComponent, DialogTitleComponent, DatetimeComponent],
})
export class ViewProgramDialogComponent extends Wrapper<ViewProgramDialogComponent> {
  programDate: Date;
  setup_expand: any = {}
  event: JoiEvent
  assets: Dictionary<Asset>
  performerDisplayType = performerDisplayTypes.staticCard
  exhibitorDisplayType = exhibitorDisplayTypes.staticCard
  resourceMap: Dictionary<JoiResource> = {}
  tagPanelDatas: Dictionary<TagPanelData> = {}
  exhibitorStandIds: string[] = []

  constructor(public dialogRef: MatDialogRef<ViewProgramDialogComponent>,    @Inject(MAT_DIALOG_DATA) public program: Program) {
    super()
    this.selectProp(exhibitorStandIdsByProgramIdReselector, program.id, 'exhibitorStandIds')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('assets', 'entities'), 'assets')
    this.subProp(this.store.select('resources', 'entities'), 'resourceMap')
    this.selectProp(programSessionsActivitesMegaTagReselector, true, 'tagPanelDatas')
    this.programDate = new Date(program.date);
    // console.log("Program data", data)
    if (program.setup_items && program.setup_items.length > 1) {
      program.setup_items.forEach(setup => {
        this.setup_expand[setup.id] = true;
      })
    }
  }
}

